// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/managed_school_information.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_school } from "./school_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/managed_school_information.proto.
 */
export const file_studyo_today_schools_v1_resources_managed_school_information = /*@__PURE__*/
  fileDesc("CkJzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvbWFuYWdlZF9zY2hvb2xfaW5mb3JtYXRpb24ucHJvdG8SIXN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcyKDAQoYTWFuYWdlZFNjaG9vbEluZm9ybWF0aW9uEjkKBnNjaG9vbBgBIAEoCzIpLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5TY2hvb2wSFQoNc3R1ZGVudF9jb3VudBgCIAEoBRIVCg10ZWFjaGVyX2NvdW50GAMgASgFQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_schools_v1_resources_school]);

/**
 * Describes the message studyo.today.schools.v1.resources.ManagedSchoolInformation.
 * Use `create(ManagedSchoolInformationSchema)` to create a new message.
 */
export const ManagedSchoolInformationSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_managed_school_information, 0);

